import { render, staticRenderFns } from "./privacy-protocol.vue?vue&type=template&id=0e166708&scoped=true&"
import script from "./privacy-protocol.vue?vue&type=script&lang=js&"
export * from "./privacy-protocol.vue?vue&type=script&lang=js&"
import style0 from "./privacy-protocol.vue?vue&type=style&index=0&id=0e166708&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e166708",
  null
  
)

export default component.exports